import { Navigate, Outlet } from "react-router-dom";
import { useChutexAuth } from "../../context/ChutexAuthContext";

export default function ComptaProtectedRoute() {
  const { isAuthenticated, loading } = useChutexAuth();
  if (loading) {
    return <div className="min-h-screen bg-white text-zinc-400 flex items-center justify-center text-sm">Chargement…</div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}

export function BlockAccountantFromOps() {
  const { isAuthenticated, loading } = useChutexAuth();
  if (loading) return null;
  try {
    const role = sessionStorage.getItem("chutex_session_role") || "";
    if (role === "ACCOUNTANT_READ_ONLY") {
      return <Navigate to="/compta" replace />;
    }
  } catch {
    /* ignore */
  }
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
